var _defs, _line, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListActiveImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "My_Checklist-After",
    "data-name": "My Checklist-After",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3357",
    "data-name": "Rectangle 3357",
    width: 20,
    height: 20,
    fill: "none",
    stroke: "#2e1c41",
    strokeWidth: 1
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_513",
    "data-name": "Line 513",
    x2: 9.34,
    transform: "translate(7.939 4.16)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7396",
    "data-name": "Group 7396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7395",
    "data-name": "Group 7395",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_922",
    "data-name": "Ellipse 922",
    cx: 1.454,
    cy: 1.454,
    r: 1.454,
    transform: "translate(2.713 2.7)",
    fill: "#de1186",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_514",
    "data-name": "Line 514",
    x2: 9.343,
    transform: "translate(7.944 10)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_923",
    "data-name": "Ellipse 923",
    cx: 1.454,
    cy: 1.454,
    r: 1.454,
    transform: "translate(2.713 8.546)",
    fill: "#de1186",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_515",
    "data-name": "Line 515",
    x2: 9.343,
    transform: "translate(7.944 15.84)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_924",
    "data-name": "Ellipse 924",
    cx: 1.454,
    cy: 1.454,
    r: 1.454,
    transform: "translate(2.713 14.39)",
    fill: "#de1186",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListActiveImageIcon);
export default __webpack_public_path__ + "static/media/list-active-image-icon.efec5db0260ccf728f520e4f20510f05.svg";
export { ForwardRef as ReactComponent };